
import { Product, Category, Store, Order, SellingModel } from '../types';

export const MOCK_STORE: Store = {
  id: "lynqar-gadgets-001",
  name: "Lynqar Gadgets Premium",
  slug: "lynqar-gadgets",
  status: 'ACTIVE',
  branding: {
    primaryColor: '#2563eb', 
    accentColor: '#1d4ed8',
    slogan: 'Premium gadgets for the next generation.',
    bannerImage: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2070&auto=format&fit=crop'
  }
};

export const MOCK_CATEGORIES: Category[] = [
  { id: 'cat1', storeId: MOCK_STORE.id, name: 'Smartphones' },
  { id: 'cat2', storeId: MOCK_STORE.id, name: 'Laptops' },
  { id: 'cat3', storeId: MOCK_STORE.id, name: 'Accessories' },
];

export const MOCK_PRODUCTS: Product[] = [
  {
    id: 'p1',
    storeId: MOCK_STORE.id,
    categoryId: 'cat1',
    name: 'Lynq Phone X1',
    description: 'The ultimate flagship smartphone with AI capabilities.',
    price: 999,
    stock: 50,
    images: [
      'https://picsum.photos/seed/phone1/600/600',
      'https://picsum.photos/seed/phone2/600/600',
      'https://picsum.photos/seed/phone3/600/600'
    ],
    sellingModel: SellingModel.INTERNAL
  },
  {
    id: 'p2',
    storeId: MOCK_STORE.id,
    categoryId: 'cat2',
    name: 'Lynq Book Pro',
    description: 'High performance laptop for developers and creators.',
    price: 1499,
    stock: 25,
    images: [
      'https://picsum.photos/seed/laptop1/600/600',
      'https://picsum.photos/seed/laptop2/600/600'
    ],
    sellingModel: SellingModel.INTERNAL
  },
  {
    id: 'p-aff-1',
    storeId: MOCK_STORE.id,
    categoryId: 'cat3',
    name: 'Logitech G-Pro Wireless (Partner)',
    description: 'The definitive gaming mouse for esports professionals.',
    price: 129,
    stock: 999,
    images: ['https://picsum.photos/seed/mouse/600/600'],
    sellingModel: SellingModel.AFFILIATE,
    externalUrl: 'https://www.amazon.com/Logitech-Wireless-Lightweight-Programmable-Buttons/dp/B07GCKQD77',
    affiliatePlatform: 'Amazon'
  },
  {
    id: 'p-aff-2',
    storeId: MOCK_STORE.id,
    categoryId: 'cat1',
    name: 'Sennheiser Accentum (Partner)',
    description: 'Hybrid noise canceling wireless headphones.',
    price: 179,
    stock: 999,
    images: ['https://picsum.photos/seed/headphone/600/600'],
    sellingModel: SellingModel.AFFILIATE,
    externalUrl: 'https://www.sennheiser.com/',
    affiliatePlatform: 'Shopify Store'
  }
];

export const MOCK_ORDERS: Order[] = [
  {
    id: 'ORD-7721',
    storeId: MOCK_STORE.id,
    userId: 'user-001',
    subtotal: 1198.00,
    taxAmount: 0,
    total: 1198.00,
    platformCommission: 119.80,
    sellerNet: 1078.20,
    status: 'DELIVERED',
    createdAt: new Date(Date.now() - 86400000 * 3).toISOString(),
  },
  {
    id: 'ORD-8842',
    storeId: MOCK_STORE.id,
    userId: 'user-002',
    subtotal: 1499.00,
    taxAmount: 0,
    total: 1499.00,
    platformCommission: 149.90,
    sellerNet: 1349.10,
    status: 'SHIPPED',
    createdAt: new Date(Date.now() - 86400000 * 1).toISOString(),
  }
];
